
import { Input } from "element-ui"

export default {
  name: "CustomContent",
  components: {
    [Input.name]: Input
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    },
    savedCustomType: {
      type: String,
      default: "defaultOption"
    },
    savedCustomText: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disabledText: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      text: "",
      curValue: "defaultOption"
    }
  },
  methods: {
    reset() {
      if (this.savedCustomType === "customOption") {
        this.curValue = this.savedCustomType
        this.text = this.savedCustomText
      } else {
        this.curValue = "defaultOption"
        this.text = ""
      }
      this.$emit("updateCustomValue", this.curValue)
      this.$emit("updateCustomText", this.text)
    },
    handleClick(item) {
      if (this.disabled) return

      this.curValue = item.preferenceValueKey
      this.$emit("updateCustomValue", this.curValue)
    },
    handleInput(value) {
      this.text = this.removeEmoji(value)
      this.$emit("updateCustomText", this.text)
    },
    handlePaste(e) {
      e.preventDefault()
      const pasteText = (e.clipboardData || window.clipboardData).getData("text")
      this.text = this.removeEmoji(pasteText)
    },
    removeEmoji(text) {
      if (!text) return ""
      const emojiReg =
        /(\u00A9|\u00AE|[\u2000-\u3300]|\uD83C[\uD000-\uDFFF]|\uD83D[\uD000-\uDFFF]|\uD83E[\uD000-\uDFFF])/g

      return text.replace(emojiReg, "").trim()
    }
  }
}
